module.exports = __webpack_public_path__ + "img/announcement-24px.4611daa3.svg";